var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextHolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1062.2 201.5",
    style: {
      enableBackground: "new 0 0 1062.2 201.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F4DBC6;}\r\n\t.st1{fill:#FBB040;}\r\n\t.st2{fill:#422E29;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.2,190.1h979.6c12.7,0,23-10.3,23-23V34.4c0-12.7-10.3-23-23-23H41.2c-12.7,0-23,10.3-23,23v132.8 C18.2,179.9,28.5,190.1,41.2,190.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26,166.4V35.2c0-7.8,6.3-14.1,14.1-14.1h10.6c7.8,0,14.1,6.3,14.1,14.1v131.2c0,7.8-6.3,14.1-14.1,14.1H40.1 C32.3,180.4,26,174.1,26,166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.8,183h-8.9c-9.5,0-17.2-8.7-17.2-19.5V38c0-10.7,7.7-19.5,17.2-19.5h8.9C59.3,18.6,67,27.3,67,38v125.5 C67,174.3,59.3,183,49.8,183z M40.9,23.7c-7,0-12.7,6.4-12.7,14.3v125.5c0,7.9,5.7,14.3,12.7,14.3h8.9c7,0,12.7-6.4,12.7-14.3V38 c0-7.9-5.7-14.3-12.7-14.3H40.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 45.4,
    cy: 35.7,
    rx: 5.5,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 45.4,
    cy: 165.9,
    rx: 5.5,
    ry: 6.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M997,166.4V35.2c0-7.8,6.3-14.1,14.1-14.1h10.6c7.8,0,14.1,6.3,14.1,14.1v131.2c0,7.8-6.3,14.1-14.1,14.1 h-10.6C1003.3,180.4,997,174.1,997,166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1020.8,183h-8.9c-9.5,0-17.2-8.7-17.2-19.5V38c0-10.7,7.7-19.5,17.2-19.5h8.9c9.5,0,17.2,8.7,17.2,19.5 v125.5C1038,174.3,1030.3,183,1020.8,183z M1011.9,23.7c-7,0-12.7,6.4-12.7,14.3v125.5c0,7.9,5.7,14.3,12.7,14.3h8.9 c7,0,12.7-6.4,12.7-14.3V38c0-7.9-5.7-14.3-12.7-14.3H1011.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 1016.4,
    cy: 35.7,
    rx: 5.5,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 1016.4,
    cy: 165.9,
    rx: 5.5,
    ry: 6.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextHolder);
export default __webpack_public_path__ + "static/media/textHolder.09d363684fb792adb97d16a1df68c6c2.svg";
export { ForwardRef as ReactComponent };